import React, { Component } from "react";
import "./Login.css";
import Alert from '@material-ui/lab/Alert'
import {CircularProgress, Typography} from "@material-ui/core";

// redux
import {
    isAuthenticatedSelector,
    tokenSelector,
} from "../../redux/selectors/auth";
import {
    authLogin,
} from "../../redux/actions/auth";
import withShipment from "../../withShipment";
import ErrorFeedbackBar from "../../components/global/ErrorFeedbackBar";
import {TextField} from "@material-ui/core";

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            display: 'none',
            loading: false,
        };
    }


    componentDidMount() {
    }

    handle = (event) => {
        event.preventDefault();
        const state = { ...this.state };
        state[event.target.name] = event.target.value;
        this.setState(state);
    };

    handleLogin = (event) => {
        event.preventDefault();
        this.setState({ loading: true })
        this.props.authLogin(this.state.username, this.state.password, this.props.history)

        setTimeout(() => {
            if (!this.props.isAuthenticated) {
                this.setState({
                    display: '',
                    loading: false
                })
            }
        }, 3000)
    };

    render() {
        return (
            <div style={{height: "90vh", display: "flex", flexDirection: "column"}}>
                <div style={{marginTop: "auto", marginBottom: "auto"}}>

                    <div className="col-12 login-container" >
                        <ErrorFeedbackBar />
                        <div className="col-12 col-md-4">
                            <div style={{marginBottom: "20px", textAlign: "center"}}>
                                <Typography variant='h5'>
                                    Login to BeeNexa
                                </Typography>
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    <div className="form-group" style={{marginBottom: "24px",marginTop:"16px"}}>
                                        <TextField variant="outlined" className="form-controll" InputLabelProps={{ shrink: true }} label="Email" name="username" onChange={this.handle} value={this.state.username} />
                                    </div>
                                    <div className="form-group" style={{marginBottom: "24px"}}>
                                        <TextField className="form-controll" variant="outlined" InputLabelProps={{ shrink: true }} label="Password" name="password" type="password" onChange={this.handle} value={this.state.password} />
                                    </div>
                                    {!this.state.loading ? <><Alert style={{ display: this.state.display, marginBottom:'16px' }} severity="error">Login Failed. Email and Password do not match. Please try again.</Alert>
                                        <div className="form-group text-center">
                                            <button className="btn btn-primary btn-block standard-margin-bottom" style={{backgroundColor: "#355942", borderColor: "#355942", padding:'16px'}} onClick={this.handleLogin}>Login</button>

                                        </div></> : <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}><CircularProgress /></div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )
    }
}

const mapStateToProps = (state) => ({
    isAuthenticated: isAuthenticatedSelector(state),
    token: tokenSelector(state),
})

const actionCreators = {
    authLogin,
}

export default withShipment({
    mapStateToProps,
    actionCreators
}, Login)